import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { UserDao } from '@app/dao/user/user.dao';
import { Subject, take } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'dependent-children-form',
    templateUrl: './dependent-children-form.component.html',
    styleUrls: ['./dependent-children-form.component.scss'],
    standalone: false
})
export class DependentChildrenFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  subscriptions: any[] = [];

  doneSubject: Subject<void> = new Subject<void>();
  page: number = 1;

  childrenCountOptions: { id: number; value: string }[] = [];

  constructor(
    protected formConstructor: PrFormConstructor,

    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor, injector);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);

    const existingCount =
      this.owners?.get(`${0}`)?.get('childrenCount')?.value || 0;
    this.childrenCountOptions = _.range(0, Math.max(6, existingCount) + 1).map(
      count => ({ id: count, value: count.toString() }),
    );

    this.prefillFromAudit();

    this.owners
      ?.get(`${0}`)
      ?.get('hasChild')
      .valueChanges.pipe(untilDestroyed(this))
      .subscribe(value => {
        if (!value) {
          this.owners?.get(`${0}`).get('childrenCount').setValue(0);
          this.form.markAllAsTouched();
        }
      });
  }

  private prefillFromAudit() {
    const ownerId = this.owners?.get(`${0}`)?.value?.ownerId;
    const pledgeOwner = this.entity?.owners?.find(
      (item: any) => item?.ownerId === ownerId,
    );
    if (!pledgeOwner || !_.isNil(pledgeOwner.householdChildren)) {
      return;
    }
    this.injector
      .get(UserDao)
      .getChildren()
      .pipe(take(1))
      .subscribe(relations => {
        const owner = this.owners?.get(`${0}`) as UntypedFormGroup;
        const children = (relations || [])
          .filter(relation => this.isCurrent(relation))
          .map(relation => this.toHouseholdChild(relation));
        if (!owner || owner.dirty || !children.length) {
          return;
        }
        this.loadChildren(owner, children);
        this.childrenCountOptions = _.range(
          0,
          Math.max(6, children.length) + 1,
        ).map(count => ({ id: count, value: count.toString() }));
      });
  }

  private isCurrent(relation: any): boolean {
    return !relation?.endDate || new Date(relation.endDate) > new Date();
  }

  onRemove(owner: UntypedFormGroup, index: number) {
    this.removeChild(owner, index);
    this.form.markAsDirty();
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
